import React, { Component } from 'react';
import logo from './../images/logo.png'
class getVendedor extends Component {

  constructor(){
    super();
    this.state = {
        cantidad : ''
    }
  }

  inputChangedHandler = (event) => {
      this.setState(
        {
          cantidad: event.target.value
        }
      )
  }
  setTeclado = (cantidad) => {
    if(cantidad ==="DEL"){
      cantidad="";
    }else{
      cantidad=this.state.cantidad+""+cantidad;
    }
    this.setState(
      {
        cantidad
      }
    )
  }

  render (){
    return (
      <div>
      <img style={{"height":"50px"}} src="https://neola.cloud/logo_neolav2.png"></img>
      <br/> <br/>
        <input className="css-cantidad-vendedor" placeholder="ID VENDEDOR" type="text" value={this.state.cantidad}  onChange={(event)=>this.inputChangedHandler(event)} />
        <div className="grid-container_teclado_vendedor" >
          <div className="div_uno"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(1)} >1</button></div>
          <div className="div_dos"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(2)} >2</button></div>
          <div className="div_tres"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(3)} >3</button></div>
          <div className="div_cuatro"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(4)} >4</button></div>
          <div className="div_cinco"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(5)} >5</button></div>
          <div className="div_seis"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(6)} >6</button></div>
          <div className="div_siete"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(7)} >7</button></div>
          <div className="div_ocho"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(8)} >8</button></div>
          <div className="div_nueve"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(9)} >9</button></div>
          <div className="div_cero"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado(0)} >0</button></div>
          <div className="div_delete"><button className="btn_teclado_vendedor" onClick={ () => this.setTeclado("DEL")} >DEL</button></div>
          <div className="div_punto"></div>
          <div className="div_enter"><button className="btn_teclado_opcion_vendedor" onClick={ () => this.props.setVendedor(this.state.cantidad)} >ENTER</button></div>
          <div className="div_guardar"><button className="btn_teclado_opcion_vendedor" onClick={ () => this.props.Abtn_encerar_cuenta()}>SALIR</button></div>
        </div>
      </div>
    )
  }
}
export default getVendedor;
